/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import RecoveryMail from "./auth/recoverymail";
import Signup from "./auth/Signup";
import Editor from "./editor";
import RecentDesigns from "./recent-designs/recent-designs";
import HowItWorks from "./how-it-works/how-it-works";
import Account from "./account/Account";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  RecoveryMail,
  Signup,
  Editor,
  RecentDesigns,
  HowItWorks,
  Account,
};